import React, {useState, useEffect} from 'react'
import './index.css'

import Header from '../Header'
import Form from '../Form'
import Footer from '../Footer'

const Login = ({validateCreds, attempts, username}) => {
  const [ width, setWidth ] = useState(window.innerWidth);
	const [ height, setHeight ] = useState(window.innerHeight);

  useEffect(()=>{
        function hideKeypad(){
                  setWidth(window.innerWidth)
                  setHeight(window.innerHeight)	 	 
        }
        window.addEventListener('resize', hideKeypad, false)
        return () => window.removeEventListener('resize', hideKeypad, false)
  },[])

  return (
    <div className="login">
	    <Header pageNumber={null}/>
	    <Form validateCreds={validateCreds} attempts={attempts} username={username}/>
	    {height>500&&<Footer />} 
    </div>
  )
}

export default Login
